var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeaderBgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 50,
    viewBox: "0 0 243 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_811_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7568 40.2785C76.4887 40.2785 76.4887 35.5501 76.4887 35.5501C76.4887 35.5501 76.4887 30.8218 71.7568 30.8218C67.0249 30.8218 67.0249 32.9387 67.0249 35.5501C67.0249 38.1615 67.0249 40.2785 71.7568 40.2785Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4328 29.4708C77.8407 29.4708 77.8407 24.067 77.8407 24.067C77.8407 24.067 77.8407 18.6631 72.4328 18.6631C67.0249 18.6631 67.0249 21.0825 67.0249 24.067C67.0249 27.0514 67.0249 29.4708 72.4328 29.4708Z",
    fill: "#819FFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_811_684)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_811_684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9606 3C66.1118 3 70.8397 7.66693 70.8397 14.6673V21.6677C70.8397 24.6345 69.6169 27.6012 67.4745 29.8007C69.4232 30.9675 70.8396 32.8793 70.8396 34.7911C70.8396 40.9164 65.9929 45 58.7228 45H13.8025C10.7733 45 10.1675 44.4896 10.1675 41.9373V28.6658H10.1675V15.8341C10.1675 8.83366 16.107 3 23.3771 3H58.9606Z",
    fill: "#CDD9FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_811_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4305 33.7724H30.0783C27.6697 33.7724 27.6694 34.3558 27.6694 35.5225C27.6694 36.6892 28.8738 38.4393 36.1003 38.4393H55.4085C62.635 38.4393 63.8394 36.6892 63.8394 35.5225C63.8394 34.3558 63.8391 33.7724 61.4305 33.7724Z",
    fill: "#FF8F5C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_811_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.474 7.74982H61.2015C66.1729 7.74982 69.0898 11.8334 69.0898 16.3436V20.0926C69.0898 24.3556 65.0061 28.751 60.0347 28.751H31.474C26.2734 28.751 22.4189 25.5223 22.4189 21.2594V16.3436C22.4189 10.9139 26.2734 7.74982 31.474 7.74982Z",
    fill: "#527BFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_811_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1488 25.6329C40.6387 25.6329 44.2786 22.2375 44.2786 18.0491C44.2786 13.8607 40.6387 10.4653 36.1488 10.4653C31.6589 10.4653 28.019 13.8607 28.019 18.0491C28.019 22.2375 31.6589 25.6329 36.1488 25.6329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3296 25.6329C62.8195 25.6329 66.4593 22.2375 66.4593 18.0491C66.4593 13.8607 62.8195 10.4653 58.3296 10.4653C53.8397 10.4653 50.1998 13.8607 50.1998 18.0491C50.1998 22.2375 53.8397 25.6329 58.3296 25.6329Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_811_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08396 40.2784C12.8159 40.2784 12.8159 38.1614 12.8159 35.5501C12.8159 32.9387 12.8159 30.8217 8.08396 30.8217C3.35206 30.8217 3.35205 35.5501 3.35205 35.5501C3.35205 35.5501 3.35206 40.2784 8.08396 40.2784Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4079 29.4708C12.8158 29.4708 12.8158 27.0514 12.8158 24.067V24.0669C12.8158 21.0825 12.8158 18.6631 7.4079 18.6631C2 18.6631 2 24.067 2 24.067C2 24.067 2.00001 29.4708 7.4079 29.4708Z",
    fill: "#819FFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_811_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8808 38V10H93.3608C95.2808 10 96.9608 10.2933 98.4008 10.88C99.8408 11.4667 100.961 12.36 101.761 13.56C102.561 14.7333 102.961 16.2 102.961 17.96C102.961 19.0533 102.681 20.0667 102.121 21C101.587 21.9067 100.827 22.6933 99.8408 23.36C101.147 24.0267 102.147 24.92 102.841 26.04C103.561 27.1333 103.921 28.4533 103.921 30C103.921 31.7067 103.534 33.16 102.761 34.36C101.987 35.56 100.907 36.4667 99.5208 37.08C98.1342 37.6933 96.5075 38 94.6408 38H83.8808ZM89.2408 33.16H94.1208C95.4275 33.16 96.4542 32.84 97.2008 32.2C97.9475 31.5333 98.3208 30.6533 98.3208 29.56C98.3208 28.4133 97.9075 27.52 97.0808 26.88C96.2542 26.2133 95.1208 25.88 93.6808 25.88H89.2408V33.16ZM89.2408 21.4H93.4808C94.6808 21.4 95.6275 21.0933 96.3208 20.48C97.0142 19.8667 97.3608 19 97.3608 17.88C97.3608 16.76 96.9742 15.8933 96.2008 15.28C95.4275 14.6667 94.3742 14.36 93.0408 14.36H89.2408V21.4ZM116.013 38.48C113.986 38.48 112.173 38.04 110.573 37.16C109 36.2533 107.76 35.0133 106.853 33.44C105.973 31.8667 105.533 30.0533 105.533 28C105.533 25.9467 105.973 24.1333 106.853 22.56C107.733 20.9867 108.96 19.76 110.533 18.88C112.106 17.9733 113.906 17.52 115.933 17.52C117.986 17.52 119.8 17.9733 121.373 18.88C122.946 19.76 124.173 20.9867 125.053 22.56C125.933 24.1333 126.373 25.9467 126.373 28C126.373 30.0533 125.933 31.8667 125.053 33.44C124.173 35.0133 122.946 36.2533 121.373 37.16C119.826 38.04 118.04 38.48 116.013 38.48ZM116.013 33.6C117 33.6 117.866 33.36 118.613 32.88C119.36 32.4 119.933 31.7467 120.333 30.92C120.76 30.0667 120.973 29.0933 120.973 28C120.973 26.9067 120.76 25.9467 120.333 25.12C119.906 24.2667 119.306 23.6 118.533 23.12C117.786 22.64 116.92 22.4 115.933 22.4C114.973 22.4 114.106 22.64 113.333 23.12C112.586 23.6 112 24.2667 111.573 25.12C111.146 25.9467 110.933 26.9067 110.933 28C110.933 29.0933 111.146 30.0667 111.573 30.92C112 31.7467 112.6 32.4 113.373 32.88C114.146 33.36 115.026 33.6 116.013 33.6ZM137.095 38.48C134.882 38.48 133.202 37.9333 132.055 36.84C130.935 35.7467 130.375 34.1867 130.375 32.16V11.76H135.655V31C135.655 31.8533 135.842 32.5067 136.215 32.96C136.589 33.3867 137.135 33.6 137.855 33.6C138.122 33.6 138.415 33.5467 138.735 33.44C139.055 33.3067 139.389 33.12 139.735 32.88L141.575 36.84C140.935 37.32 140.215 37.7067 139.415 38C138.642 38.32 137.869 38.48 137.095 38.48ZM127.135 22.48V18H140.655V22.48H127.135ZM143.709 38V33.96C143.709 33.1867 143.949 32.3333 144.429 31.4C144.909 30.4667 145.576 29.5333 146.429 28.6C147.282 27.6667 148.282 26.8 149.429 26L153.669 22.96C154.256 22.56 154.802 22.1067 155.309 21.6C155.842 21.0933 156.269 20.5467 156.589 19.96C156.936 19.3467 157.109 18.76 157.109 18.2C157.109 17.5067 156.936 16.88 156.589 16.32C156.269 15.76 155.789 15.32 155.149 15C154.509 14.68 153.722 14.52 152.789 14.52C151.989 14.52 151.269 14.68 150.629 15C150.016 15.32 149.509 15.7467 149.109 16.28C148.709 16.8133 148.429 17.3867 148.269 18L142.629 17.04C142.896 15.7067 143.469 14.4667 144.349 13.32C145.229 12.1733 146.376 11.2533 147.789 10.56C149.229 9.84 150.856 9.48 152.669 9.48C154.749 9.48 156.536 9.85333 158.029 10.6C159.522 11.3467 160.669 12.3733 161.469 13.68C162.296 14.96 162.709 16.4533 162.709 18.16C162.709 19.8933 162.229 21.44 161.269 22.8C160.336 24.1333 159.042 25.3867 157.389 26.56L153.589 29.32C152.816 29.8533 152.149 30.44 151.589 31.08C151.029 31.72 150.602 32.4267 150.309 33.2H163.069V38H143.709ZM166.113 38V10H171.393V34.28L171.113 38H166.113ZM177.433 38.48C175.753 38.48 174.326 38.0533 173.153 37.2C172.006 36.3467 171.126 35.1333 170.513 33.56C169.9 31.9867 169.593 30.1333 169.593 28C169.593 25.84 169.9 23.9867 170.513 22.44C171.126 20.8667 172.006 19.6533 173.153 18.8C174.326 17.9467 175.753 17.52 177.433 17.52C179.273 17.52 180.86 17.9467 182.193 18.8C183.553 19.6533 184.606 20.8667 185.353 22.44C186.1 23.9867 186.473 25.84 186.473 28C186.473 30.1333 186.1 31.9867 185.353 33.56C184.606 35.1333 183.553 36.3467 182.193 37.2C180.86 38.0533 179.273 38.48 177.433 38.48ZM176.073 33.64C177.033 33.64 177.873 33.4 178.593 32.92C179.34 32.44 179.926 31.7733 180.353 30.92C180.78 30.0667 180.993 29.0933 180.993 28C180.993 26.9067 180.78 25.9333 180.353 25.08C179.953 24.2267 179.38 23.5733 178.633 23.12C177.913 22.64 177.073 22.4 176.113 22.4C175.206 22.4 174.393 22.64 173.673 23.12C172.953 23.6 172.393 24.2667 171.993 25.12C171.593 25.9467 171.393 26.9067 171.393 28C171.393 29.0933 171.593 30.0667 171.993 30.92C172.393 31.7733 172.94 32.44 173.633 32.92C174.353 33.4 175.166 33.64 176.073 33.64ZM189.701 38V10H195.661L203.821 22.08L211.981 10H217.901V38H212.461V18.56L203.821 31.28L195.181 18.6V38H189.701ZM231.278 38.48C229.305 38.48 227.558 38.04 226.038 37.16C224.518 36.2533 223.318 35.0133 222.438 33.44C221.585 31.8667 221.158 30.0533 221.158 28C221.158 25.9467 221.598 24.1333 222.478 22.56C223.385 20.9867 224.611 19.76 226.158 18.88C227.731 17.9733 229.531 17.52 231.558 17.52C233.318 17.52 234.931 17.9867 236.398 18.92C237.891 19.8267 239.078 21.1733 239.958 22.96C240.865 24.72 241.318 26.8667 241.318 29.4H226.158L226.638 28.92C226.638 29.9067 226.878 30.7733 227.358 31.52C227.865 32.24 228.505 32.8 229.278 33.2C230.078 33.5733 230.931 33.76 231.838 33.76C232.931 33.76 233.825 33.5333 234.518 33.08C235.211 32.6 235.745 31.9867 236.118 31.24L240.838 33.08C240.278 34.2 239.545 35.1733 238.638 36C237.758 36.8 236.705 37.4133 235.478 37.84C234.251 38.2667 232.851 38.48 231.278 38.48ZM226.918 25.96L226.438 25.48H236.078L235.638 25.96C235.638 25 235.411 24.24 234.958 23.68C234.505 23.0933 233.945 22.6667 233.278 22.4C232.638 22.1333 232.011 22 231.398 22C230.785 22 230.131 22.1333 229.438 22.4C228.745 22.6667 228.145 23.0933 227.638 23.68C227.158 24.24 226.918 25 226.918 25.96Z",
    fill: "#2E60FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_811_684",
    x: 65.0249,
    y: 18.6631,
    width: 12.8159,
    height: 25.6153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_811_684",
    x: 8.16748,
    y: 3,
    width: 62.6724,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_811_684",
    x: 5.16748,
    y: 0,
    width: 68.6724,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_811_684",
    x: 27.6694,
    y: 33.7724,
    width: 36.1699,
    height: 5.66693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "shape",
    result: "effect1_innerShadow_811_684"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_811_684",
    x: 20.4189,
    y: 3.74982,
    width: 52.6709,
    height: 27.0012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72 0 0 0 0 0.786316 0 0 0 0 1 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-lighter",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_811_684",
    x: 26.019,
    y: 8.46533,
    width: 42.4404,
    height: 19.1675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_811_684",
    x: 0,
    y: 18.6631,
    width: 12.8159,
    height: 25.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_811_684",
    x: 80.8809,
    y: 9.47998,
    width: 160.437,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_684",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeaderBgWhite);
export default __webpack_public_path__ + "static/media/logo-header-bg-white.d91c23ff2bc617c7e2a448dea7979367.svg";
export { ForwardRef as ReactComponent };